export default __webpack_public_path__ + "static/media/a019-5.e1a72255.svg";